module.exports = __webpack_public_path__ + "static/media/MV.d0e80a82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MV.svg
// module id = 321
// module chunks = 0